import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"],
  _excluded2 = ["children"];
import { LayoutBox, Modal } from 'breeze-intelligence-kit';
import { jsx as _jsx } from "react/jsx-runtime";
export const NoAccessModalEmptyState = _ref => {
  let {
      children
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(Modal.Body, {
    children: /*#__PURE__*/_jsx(LayoutBox, Object.assign({}, rest, {
      children: children
    }))
  });
};
export const NoAccessModalEmptyStateHeader = _ref2 => {
  let {
      children
    } = _ref2,
    rest = _objectWithoutPropertiesLoose(_ref2, _excluded2);
  return /*#__PURE__*/_jsx(Modal.Header, {
    children: /*#__PURE__*/_jsx(Modal.Heading, Object.assign({}, rest, {
      children: children
    }))
  });
};